var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
    fill: "#F4F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75129 11.2436V7.05297C8.75129 6.62437 8.40386 6.27694 7.97526 6.27694C7.54665 6.27694 7.19922 6.62437 7.19922 7.05297V11.2436C7.19922 11.6722 7.54665 12.0196 7.97526 12.0196C8.40386 12.0196 8.75129 11.6722 8.75129 11.2436ZM7.97526 3.59961C7.54665 3.59961 7.19922 3.94704 7.19922 4.37565C7.19922 4.80425 7.54665 5.15168 7.97526 5.15168C8.40386 5.15168 8.75129 4.80425 8.75129 4.37565C8.75129 3.94704 8.40386 3.59961 7.97526 3.59961Z",
    fill: "#6544C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.79694b42d3c5ce15af5e0d5df063ec8f.svg";
export { ForwardRef as ReactComponent };